module.exports = __webpack_public_path__ + "m.no2.65594e19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/m.no2.jpg
// module id = JBux
// module chunks = 0